import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import registerServiceWorker from 'registerServiceWorker'
import store from 'store'
import 'semantic-ui-less/semantic.less'
import 'vmo-library/dist/index.css'
import ErrorBoundary from 'components/pages/ErrorBoundary'
import 'global-styles'
import App from 'App'

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Provider>,
  document.getElementById('root'),
)
registerServiceWorker()
